import { Button, Link } from 'omakase';
import { FC } from 'react';
import { IconCalendarPlus } from '@tock/icons';
import { ReceiptButtonProps } from 'components/business/receipts/ReceiptActionButtons';

const ReceiptCalendarButton: FC<ReceiptButtonProps> = ({ variant = 'button', ...rest }) => {
  return variant === 'button' ? (
    <Button
      variant="basic"
      size="medium"
      iconStart={<IconCalendarPlus />}
      data-testid="export-booking"
      fullWidth
      {...rest}
    >
      Calendar
    </Button>
  ) : (
    <Link data-testid="export-booking" {...rest}>
      Add to calendar
    </Link>
  );
};

export default ReceiptCalendarButton;
